import { render, staticRenderFns } from "./Subroles.vue?vue&type=template&id=06c5cb7f&scoped=true&"
import script from "./Subroles.vue?vue&type=script&lang=js&"
export * from "./Subroles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5cb7f",
  null
  
)

export default component.exports